__turbopack_context__.v({
  "modalBody": "z_E0lq_modalBody",
  "modalFooter": "z_E0lq_modalFooter",
});
